// El ancestro que de verdad scrollea. En este app NO es la ventana: el
// `<main>` de SidebarLayout tiene su propio `overflow-y-auto`, así que
// cualquier medida contra `window.innerHeight` (o una fórmula con vh/svh)
// sale de más por el alto del navbar y el padding del layout.
export const findScrollParent = (el) => {
  let scroller = el?.parentElement;
  while (scroller && scroller !== document.body) {
    const { overflowY } = window.getComputedStyle(scroller);
    if (overflowY === "auto" || overflowY === "scroll") return scroller;
    scroller = scroller.parentElement;
  }
  return null;
};
